import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  border-radius: 4px;
  padding: ${props => props.theme.whiteLabel.spacing.sp16};
  background-color: ${props => props.backgroundColor || props.theme.colors.grey.tone100};
`

export const StatusMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`
